import { Building2, Layers, PencilRuler, Sofa, Wrench, Boxes, Home, Hammer, ShieldCheck, Award } from "lucide-react";

export const SERVICE_ICONS = {
  building: Building2,
  layers: Layers,
  design: PencilRuler,
  interior: Sofa,
  renovation: Wrench,
  furniture: Boxes,
  home: Home,
  hammer: Hammer,
  shield: ShieldCheck,
  award: Award,
};

export const SERVICE_ICON_OPTIONS = [
  { value: "building", label: "Building" },
  { value: "layers", label: "Layers / Commercial" },
  { value: "design", label: "Design / Ruler" },
  { value: "interior", label: "Interior / Sofa" },
  { value: "renovation", label: "Renovation / Wrench" },
  { value: "furniture", label: "Furniture / Box" },
  { value: "home", label: "Home" },
  { value: "hammer", label: "Hammer" },
  { value: "shield", label: "Warranty / Shield" },
  { value: "award", label: "Award" },
];

export function serviceIcon(key) {
  return SERVICE_ICONS[key] || Building2;
}
